import { render, staticRenderFns } from "./JournalSectionList.vue?vue&type=template&id=0869adc2&scoped=true&"
import script from "./JournalSectionList.vue?vue&type=script&lang=js&"
export * from "./JournalSectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0869adc2",
  null
  
)

export default component.exports